module.exports = __webpack_public_path__ + "static/media/tgle-almazen-black.2c0964ce.png";